import { render, staticRenderFns } from "./PublicationsView.vue?vue&type=template&id=02bedd71"
import script from "./PublicationsView.vue?vue&type=script&lang=js"
export * from "./PublicationsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports